import { ControlConstants } from "../../control/constant/ControlConstants";
import { ButtonProperties } from "../../control/properties/ButtonProperties";
import { SpriteProperties } from "../../control/properties/SpriteProperties";
import { TextFieldProperties } from "../../control/properties/TextFieldProperties";
import { RealityCheckDialog } from "../display/RealityCheckDialog";
import { CommonLang } from "../lang/CommonLang";
import { CommonFontStyle } from "../style/CommonFontStyle";
import { CommonStyle } from "../style/CommonStyle";
import { AbstractMessageDialogProperties } from "./AbstractMessageDialogProperties";
/**
 * AbstractRealityCheckDialogProperties.ts
 */
export class AbstractRealityCheckDialogProperties extends AbstractMessageDialogProperties {
    equals(other) {
        return super.equals(other) &&
            this.wagerHistoryButtonProperties.equals(other.wagerHistoryButtonProperties) &&
            this.exitGameButtonProperties.equals(other.exitGameButtonProperties) &&
            this.continueButtonProperties.equals(other.continueButtonProperties) &&
            this.winFieldProperties.equals(other.winFieldProperties) &&
            this.wageredFieldProperties.equals(other.wageredFieldProperties);
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.backgroundProperties = new SpriteProperties(CommonStyle.MESSAGE_DIALOG_1, CommonStyle.MODULE);
        this.wagerHistoryButtonProperties = new ButtonProperties(CommonStyle.DIALOG_BUTTON_1, CommonStyle.MODULE);
        this.wagerHistoryButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.DIALOG_BUTTON_1, null, CommonLang.WAGER_HISTORY_BUTTON, ControlConstants.CENTER, ControlConstants.CENTER);
        this.exitGameButtonProperties = new ButtonProperties(CommonStyle.DIALOG_BUTTON_1, CommonStyle.MODULE);
        this.exitGameButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.DIALOG_BUTTON_1, null, CommonLang.EXIT_GAME_BUTTON, ControlConstants.CENTER, ControlConstants.CENTER);
        this.continueButtonProperties = new ButtonProperties(CommonStyle.DIALOG_BUTTON_1, CommonStyle.MODULE);
        this.continueButtonProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.DIALOG_BUTTON_1, null, CommonLang.CONTINUE_BUTTON, ControlConstants.CENTER, ControlConstants.CENTER);
        this.winFieldProperties = new TextFieldProperties(CommonFontStyle.DIALOG_MESSAGE, null, null, ControlConstants.CENTER, ControlConstants.CENTER);
        this.wageredFieldProperties = new TextFieldProperties(CommonFontStyle.DIALOG_MESSAGE, null, null, ControlConstants.CENTER, ControlConstants.CENTER);
    }
    getClass() {
        return RealityCheckDialog;
    }
    getClassName() {
        return "RealityCheckDialog";
    }
}
//# sourceMappingURL=AbstractRealityCheckDialogProperties.js.map